import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el pack después de comprar?',
  a: 'Al completar el pago recibís un mail automático con el link de descarga. El acceso es inmediato. Si no te llega en 10 minutos, revisá la carpeta de spam o escribinos a soportesaberclick@gmail.com.'
}, {
  q: '¿Sirve si nunca hice publicidad en redes antes?',
  a: 'Sí, está hecho exactamente para eso. Todo está explicado paso a paso con ejemplos concretos, sin suponer ningún conocimiento previo.'
}, {
  q: '¿Y si ya tengo experiencia en redes? ¿Me sirve igual?',
  a: 'Sí. Los módulos de publicidad paga, cierre de ventas y estrategia de contenido mejoran resultados en cualquier nivel. Los bonus solos ya valen la inversión.'
}, {
  q: '¿Funciona para cualquier rubro?',
  a: 'Sí. Ropa, gastronomía, servicios, productos digitales, belleza, hogar y más. Todos los ejemplos son de rubros argentinos variados.'
}, {
  q: '¿Los bonus están incluidos en las dos opciones?',
  a: 'Los 4 bonus están incluidos solo en el Megapack Completo. El Pack Esencial incluye únicamente las 6 guías.'
}, {
  q: '¿Por qué no aprendo esto gratis en YouTube?',
  a: 'En YouTube hay información dispersa, en inglés o pensada para otros mercados. Este pack está hecho para el emprendedor argentino, con ejemplos locales y ordenado paso a paso en un solo lugar.'
}, {
  q: '¿Necesito una inversión grande para aplicar lo que enseñan?',
  a: 'No. La mitad del pack está dedicada a estrategias orgánicas gratuitas. La guía de publicidad paga está diseñada para presupuestos pequeños.'
}, {
  q: '¿Por qué elegir el Megapack y no el Esencial?',
  a: 'Por $10.000 más recibís herramientas que valen $39.960: las 30 ideas de contenido, los scripts de venta y el checklist de lanzamiento te ahorran semanas de trabajo.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días completos. Si no te convence, escribís a soportesaberclick@gmail.com y te devolvemos el 100% sin preguntas ni formularios.'
}];
export function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="py-20 bg-slate-50 px-4" data-id="element-96">
      <div className="max-w-3xl mx-auto" data-id="element-97">
        <h2 className="text-3xl md:text-4xl font-bold text-navy text-center mb-12" data-id="element-98">
          Preguntas frecuentes
        </h2>

        <div className="space-y-4" data-id="element-99">
          {faqs.map((faq, idx) => <div key={idx} className={`bg-white border rounded-xl overflow-hidden transition-all duration-200 ${openIdx === idx ? 'border-sky shadow-md' : 'border-slate-200 hover:border-slate-300'}`} data-id="element-100">
              <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} aria-expanded={openIdx === idx} aria-controls={`faq-panel-${idx}`} id={`faq-trigger-${idx}`} className="w-full flex items-center justify-between p-5 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky focus-visible:ring-inset rounded-xl" data-id="element-101">
                <span className="font-bold text-navy pr-4" data-id="element-102">{faq.q}</span>
                <ChevronDown aria-hidden="true" className={`w-5 h-5 text-slate-400 transition-transform duration-200 shrink-0 ${openIdx === idx ? 'rotate-180 text-sky' : ''}`} data-id="element-103" />
              </button>

              <div id={`faq-panel-${idx}`} role="region" aria-labelledby={`faq-trigger-${idx}`} className={`grid px-5 transition-all duration-300 ease-in-out ${openIdx === idx ? 'grid-rows-[1fr] pb-5 opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-104">
                <div className="overflow-hidden" data-id="element-105">
                  <p className="text-slate-600 text-sm leading-relaxed" data-id="element-106">
                    {faq.a}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}